<div class="modal" [ngStyle]="{'display': visible}" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle"
  aria-hidden="true">
  <div class="modal-backdrop fade in" style="height: 2607px;"></div>
  <div class="modal-dialog modal-lg">
    <div class="modal-content" style="border-radius: 7px;">
      <div class="modal-header"
        style="color:white;line-height: 0.5;border-bottom: 1px solid var(--brand-primary-color);background: var(--brand-primary-color);border-top-right-radius: 7px;border-top-left-radius: 7px;">
        <button type="button" class="close" data-dismiss="modal" (click)="close()">&times;</button>
        <div class="modal-title" style="font-weight: 500">
          <span style="margin-left: 10px;">{{ 'update' | translate }} <b>{{studentName}}</b>{{ 'sContactInfo' | translate }}</span>
        </div>
      </div>
      <div class="modal-body" style="height: 400px;overflow-y: scroll">
        <!-- student basic info -->
        <form class="form student-detail-summary">
          <div class="row" style="margin: 0;">
            <div class="col-md-9">
              <h4>{{ 'contactInfo' | translate }}: &nbsp;<i *ngIf="profileIsLoading" class="fa fa-spinner fa-spin" aria-hidden="true"
                  style="vertical-align: middle"></i></h4>
            </div>
            <!-- father info -->
            <div class="row" style="margin: 0;margin-top: 15px;">
              <div class="col-md-12">
                <h5>{{ 'fathersInfo' | translate }}:</h5>
              </div>
              <div class="col-md-2"  style="text-align: center;justify-content: center;display: flex;flex-direction: column;align-items: center;">
                <div class="cropme-student-edit parent-photo-main-container"
                  style="width: 90px;height: 90px;margin: 0 auto;border: 1px dashed #e0e0e0;text-align: center;overflow:hidden;">
                  <img *ngIf="fatherImagePreview" class="img-responsive" style="width:100%;height:100%;object-fit:cover;"
                    [src]="fatherImagePreview" id="father-selected-image">
                  <i *ngIf="!fatherImagePreview" class="fa fa-user" style="font-size: 40px;color: #cccccc;line-height: 90px;"></i>
                </div>
               <div class="upload-parent-and-delete-container">
                 <input id="selectFatherPic" (change)="onContactImageSelected($event, 'father')" type="file"
                  class="input-style" accept="image/*" style="width:1px; height: 1px">
                <h5 (click)="triggerContactImageUpload('selectFatherPic')" class="image-edit"
                  style="text-align: center;cursor: pointer;display: inline-block;border: 1px solid #e2e2e2;padding: 5px 8px;margin: 0.5em 0 0;color: var(--secondary-btn-bg-color);font-size: 9px;text-transform: uppercase;">
                 <i class="ri-arrow-up-line"></i> {{ 'upload' | translate }}</h5>
                 <div *ngIf="fatherImagePreview && fatherImagePreview !== studentData.defaultImageURL" (click)="removeContactImage('father')" class="delete-icon-for-parent-image">
                  <i class="ri-delete-bin-line"></i>
                 </div>
               </div>
              </div>
              <div class="col-md-10">
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <input [(ngModel)]="studentData.parentName" id="edit-student-fathername"
                        name="edit-student-fathername" type="text" class="form-control">
                      <label for="edit-student-fathername">{{ 'fathersName' | translate }}<span style="color: #F44336;">*</span></label>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <input type="text" placeholder="Enter contact number" id="edit-student-father-mobile-number"
                        [ngModelOptions]="{standalone: true}" class="form-control" [ngClass]="{
                          'edit-student-field': !invalidEditFatherMobileNumber,
                          'edit-student-field-error': invalidEditFatherMobileNumber
                        }" #editFatherMobileNumber (input)="handleDebounceEditFatherMobileNumber(editFatherMobileNumber)"
                        autocomplete="off" [(ngModel)]="editSelectedFatherContact" value="{{editSelectedFatherContact}}"
                        (keydown)="handleKeyDown($event)" maxlength="20" />
                      <label for="edit-student-fathernum">{{ 'contactNumber' | translate }}<span style="color: #F44336;">*</span></label>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <select [(ngModel)]="studentData.fatherOccupation" id="edit-student-father-occupation" name="select1"
                        class="form-control"
                        style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                        <option [value]="null">{{ 'selectOccupation' | translate }}</option>
                        <option *ngFor="let o of occupationList" [value]="o.value">{{o.name}}</option>
                      </select>
                      <label for="edit-student-father-occupation">{{ 'occupation' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <input [(ngModel)]="studentData.fatherQualification" id="edit-student-fatherqual"
                        name="edit-student-fatherqual" type="text" class="form-control">
                      <label for="edit-student-fatherqual">{{ 'educationalQualification' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <input [(ngModel)]="studentData.fatherAnnualIncome" id="edit-student-father-annual-income"
                        name="edit-student-father-annual-income" type="text" class="form-control"
                        (keydown)="handleKeyDown($event)">
                      <label for="edit-student-father-annual-income">{{ 'annualIncome' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <input [(ngModel)]="studentData.fatherPinCode" id="edit-student-father-pin-codee"
                        name="edit-student-father-pin-code" type="text" class="form-control"
                        (keydown)="handleKeyDown($event)" maxlength="6">
                      <label for="edit-student-father-pin-code">{{ 'pinCode' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <input id="edit-father-email" name="fatherEmail" [(ngModel)]="studentData.emailId" type="text"
                        class="form-control">
                      <label for="edit-father-email">{{ 'fatherEmail' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <textarea [(ngModel)]="studentData.address" id="edit-student-fatheraddress"
                        name="edit-student-fatheraddress" class="form-control" rows="3"
                        style="text-transform: initial;padding: 12px 10px;margin-top: 5px;"></textarea>
                      <label for="edit-student-fatheraddress">{{ 'contactAddress' | translate }}<span style="color: #F44336;">*</span></label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- mother info -->
            <div class="row" style="margin: 0;">
              <div class="col-md-12">
                <h5>{{ 'mothersInfo' | translate }}:</h5>
              </div>
              <div class="col-md-2" style="text-align: center;justify-content: center;display: flex;flex-direction: column;align-items: center;">
                <div class="cropme-student-edit parent-photo-main-container"
                  style="width: 90px;height: 90px;margin: 0 auto;border: 1px dashed #e0e0e0;text-align: center;overflow:hidden;">
                  <img *ngIf="motherImagePreview" class="img-responsive" style="width:100%;height:100%;object-fit:cover;"
                    [src]="motherImagePreview" id="mother-selected-image">
                  <i *ngIf="!motherImagePreview" class="fa fa-user" style="font-size: 40px;color: #cccccc;line-height: 90px;"></i>
                </div>
                  <div class="upload-parent-and-delete-container">
                <input id="selectMotherPic" (change)="onContactImageSelected($event, 'mother')" type="file"
                  class="input-style" accept="image/*" style="width:1px; height: 1px">
                <h5 (click)="triggerContactImageUpload('selectMotherPic')" class="image-edit"
                  style="text-align: center;cursor: pointer;display: inline-block;border: 1px solid #e2e2e2;padding: 5px 8px;margin: 0.5em 0 0;color: var(--secondary-btn-bg-color);font-size: 9px;text-transform: uppercase;">
                  {{ 'upload' | translate }}</h5>
                  <div *ngIf="motherImagePreview && motherImagePreview !== studentData.defaultImageURL" (click)="removeContactImage('mother')" class="delete-icon-for-parent-image">
                  <i class="ri-delete-bin-line"></i>
                 </div>
                 </div>
              </div>
              <div class="col-md-10">
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <input [(ngModel)]="studentData.motherName" name="edit-student-mothername"
                        id="edit-student-mothername" type="text" class="form-control">
                      <label for="edit-student-mothername">{{ 'mothersName' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <input type="text" placeholder="Enter contact number" id="edit-student-mother-mobile-number"
                        [ngModelOptions]="{standalone: true}" class="form-control" [ngClass]="{
                          'edit-student-field': !invalidEditMotherMobileNumber,
                          'edit-student-field-error': invalidEditMotherMobileNumber
                        }" #editMotherMobileNumber (input)="handleDebounceEditMotherMobileNumber(editMotherMobileNumber)"
                        autocomplete="off" [(ngModel)]="editSelectedMotherContact" value="{{editSelectedMotherContact}}"
                        (keydown)="handleKeyDown($event)" maxlength="20" />
                      <label for="edit-student-mothernum">{{ 'contactNumber' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <select [(ngModel)]="studentData.motherOccupation" id="edit-student-mother-occupation"
                        name="edit-student-mother-occupation" class="form-control"
                        style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                        <option [value]="null">{{ 'selectOccupation' | translate }}</option>
                        <option *ngFor="let o of occupationList" [value]="o.value">{{o.name}}</option>
                      </select>
                      <label for="edit-student-mother-occupation">{{ 'occupation' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <input [(ngModel)]="studentData.motherQualification" name="edit-student-motherqual"
                        id="edit-student-motherqual" type="text" class="form-control">
                      <label for="edit-student-motherqual">{{ 'educationalQualification' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <input [(ngModel)]="studentData.motherAnnualIncome" id="edit-student-mother-annual-income"
                        name="edit-student-mother-annual-income" type="text" class="form-control"
                        (keydown)="handleKeyDown($event)">
                      <label for="edit-student-mother-annual-income">{{ 'annualIncome' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <input [(ngModel)]="studentData.motherPinCode" id="edit-student-mother-pin-codee"
                        name="edit-student-mother-pin-code" type="text" class="form-control"
                        (keydown)="handleKeyDown($event)" maxlength="6">
                      <label for="edit-student-mother-pin-code">{{ 'pinCode' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <input id="edit-mother-email" name="motherEmail" [(ngModel)]="studentData.motherEmail" type="text"
                        class="form-control">
                      <label for="edit-mother-email">{{ 'motherEmail' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <textarea [(ngModel)]="studentData.motherAddress" id="edit-student-motheradd"
                        name="edit-student-motheradd" class="form-control" rows="3"
                        style="text-transform: initial;padding: 12px 10px;margin-top: 5px;"></textarea>
                      <label for="edit-student-motheradd">{{ 'contactAddress' | translate }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Guardian info -->
            <div class="row" style="margin: 0;">
              <div class="col-md-12">
                <h5>{{ 'guardiansInfo' | translate }}:</h5>
              </div>
              <div class="col-md-2" style="text-align: center;justify-content: center;display: flex;flex-direction: column;align-items: center;">
                <div class="cropme-student-edit parent-photo-main-container"
                  style="width: 90px;height: 90px;margin: 0 auto;border: 1px dashed #e0e0e0;text-align: center;overflow:hidden;">
                  <img *ngIf="guardianImagePreview" class="img-responsive" style="width:100%;height:100%;object-fit:cover;"
                    [src]="guardianImagePreview" id="guardian-selected-image">
                  <i *ngIf="!guardianImagePreview" class="fa fa-user" style="font-size: 40px;color: #cccccc;line-height: 90px;"></i>
                </div>
               <div class="upload-parent-and-delete-container">
                 <input id="selectGuardianPic" (change)="onContactImageSelected($event, 'guardian')" type="file"
                  class="input-style" accept="image/*" style="width:1px; height: 1px">
                <h5 (click)="triggerContactImageUpload('selectGuardianPic')" class="image-edit"
                  style="text-align: center;cursor: pointer;display: inline-block;border: 1px solid #e2e2e2;padding: 5px 8px;margin: 0.5em 0 0;color: var(--secondary-btn-bg-color);font-size: 9px;text-transform: uppercase;">
                  {{ 'upload' | translate }}</h5>
                   <div *ngIf="guardianImagePreview && guardianImagePreview !== studentData.defaultImageURL" (click)="removeContactImage('guardian')" class="delete-icon-for-parent-image">
                  <i class="ri-delete-bin-line"></i>
                 </div>
               </div>
              </div>
              
              <div class="col-md-10">
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <input [(ngModel)]="studentData.guardianName" id="edit-student-guardianname"
                        name="edit-student-guardianname" type="text" class="form-control">
                      <label for="edit-student-guardianname">{{ 'guardiansName' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <input type="text" placeholder="Enter contact number" id="edit-student-guardian-mobile-number"
                        [ngModelOptions]="{standalone: true}" class="form-control" [ngClass]="{
                          'edit-student-field': !invalidEditGuardianMobileNumber,
                          'edit-student-field-error': invalidEditGuardianMobileNumber
                        }" #editGuardianMobileNumber
                        (input)="handleDebounceEditGuardianMobileNumber(editGuardianMobileNumber)" autocomplete="off"
                        [(ngModel)]="editSelectedGuardianContact" value="{{editSelectedGuardianContact}}"
                        (keydown)="handleKeyDown($event)" maxlength="20" />
                      <label for="edit-student-guardiannum">{{ 'contactNumber' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <select [(ngModel)]="studentData.guardianOccupation" id="edit-student-gardian-occupation"
                        name="edit-student-gardian-occupation" class="form-control"
                        style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;">
                        <option [value]="null">{{ 'selectOccupation' | translate }}</option>
                        <option *ngFor="let o of occupationList" [value]="o.value">{{o.name}}</option>
                      </select>
                      <label for="edit-student-gardian-occupation">{{ 'occupation' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <input [(ngModel)]="studentData.guardianQualification" id="edit-student-guardianqual"
                        name="edit-student-guardianqual" type="text" class="form-control">
                      <label for="edit-student-guardianqual">{{ 'educationalQualification' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <input [(ngModel)]="studentData.guardianAnnualIncome" id="edit-student-guardian-annual-income"
                        name="edit-student-guardian-annual-income" type="text" class="form-control"
                        (keydown)="handleKeyDown($event)">
                      <label for="edit-student-guardian-annual-income">{{ 'annualIncome' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <input [(ngModel)]="studentData.guardianPinCode" id="edit-student-guardian-pin-codee"
                        name="edit-student-guardian-pin-code" type="text" class="form-control"
                        (keydown)="handleKeyDown($event)" maxlength="6">
                      <label for="edit-student-guardian-pin-code">{{ 'pinCode' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <textarea [(ngModel)]="studentData.guardianAddress" id="edit-student-guardianadd"
                        name="edit-student-guardianadd" class="form-control" rows="3"
                        style="text-transform: initial;padding: 12px 10px;margin-top: 5px;"></textarea>
                      <label for="edit-student-guardianadd">{{ 'contactAddress' | translate }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button [disabled]="profileIsLoading" class="btn btn-primary active" type="button" data-dismiss="modal"
          (click)="save()">{{button_text}}</button>
        <button type="button" class="btn btn-primary active" data-dismiss="modal" (click)="close()">{{ 'cancel' | translate }}</button>
      </div>
    </div>
  </div>
</div>